import axiosInstance from "services/axiosMiddleware";

export async function sendFeedback(feedbackData){
try{
    console.log('feedbackData',feedbackData)
    const response = await axiosInstance.post('feedback/sendFeedback', feedbackData);
return response
}catch(error){
     console.error('Error fetching Asana data:', error);
    throw error; 
}
}